export const INVALID_ARTIFACT_NAME_MESSAGE =
  'Artifact names must be 255 characters or fewer, start and end with a letter or number, and contain only letters, numbers, spaces, periods, hyphens, and underscores.'

const ARTIFACT_NAME_BOUNDARY_PATTERN = /^[\p{L}\p{N}]$/u
const ARTIFACT_NAME_MARK_PATTERN = /^\p{M}$/u
const ALLOWED_ARTIFACT_NAME_SEPARATORS = new Set([' ', '.', '-', '_'])
const MAX_ARTIFACT_NAME_CHARACTERS = 255

export function isValidArtifactName(name: string): boolean {
  const characters = Array.from(name)
  if (characters.length === 0 || characters.length > MAX_ARTIFACT_NAME_CHARACTERS) return false
  const [firstCharacter] = characters
  if (firstCharacter === undefined || !ARTIFACT_NAME_BOUNDARY_PATTERN.test(firstCharacter)) return false

  let previousAllowsMark = true
  for (const character of characters.slice(1)) {
    if (ARTIFACT_NAME_BOUNDARY_PATTERN.test(character)) {
      previousAllowsMark = true
    } else if (ARTIFACT_NAME_MARK_PATTERN.test(character)) {
      if (!previousAllowsMark) return false
    } else if (ALLOWED_ARTIFACT_NAME_SEPARATORS.has(character)) {
      previousAllowsMark = false
    } else {
      return false
    }
  }

  return previousAllowsMark
}
